import adultTraining from "@static/images/campaigns/adultTraining.jpg"
import youthWorkshops from "@static/images/campaigns/youthWorkshops.jpg"

const calloutTextBlocks = [
  {
    heading: "Awareness & Visibility",
    body:
      "2 in 3 LGBTQIA+ youth still experience abuse for being who they are. Our campaigns start crucial conversations to amplify the voice of the next generation.",
  },
  {
    // new line character
    heading: `LGBTQIA+ /n Education`,
    body:
      "Creating an Australia free from discrimination is up to us all. Our LGBTQIA+ training, workshops and resources enable others to champion inclusivity, no matter their location.",
  },
  {
    heading: "Life-Affirming Programs",
    body:
      "Our preventive model of mental health support tackles social isolation through spaces where LGBTQIA+ youth belong and by empowering the next generation of leaders.",
  },
]

const imageTextBlocks = [
  {
    image: youthWorkshops,
    heading: "Visibility merch",
    text:
      "Show your pride and drive inclusion - Minus18 rainbow merch makes a difference. Literally! 100% of your purchase supports youth programs and events.",
    links: [
      {
        link: "/shop/pride",
        label: "Pride",
      },
      {
        link: "/shop/school",
        label: "Schools",
      },
      {
        link: "/shop/workplace",
        label: "Workplaces",
      },
    ],
  },
  {
    image: adultTraining,
    heading: "Workshops & training",
    text:
      "Our highly experienced presenters head into schools and workplaces to deliver LGBTQIA+ inclusion training, keynotes, and workshops. Customisable for all knowledge levels.",
    links: [
      {
        link: "/workshops/schools",
        label: "School workshops",
      },
      {
        link: "/workshops/workplace",
        label: "Workplace training",
      },
    ],
  },
]

export default { calloutTextBlocks, imageTextBlocks }
